import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'outlaw-floating-textarea',
  templateUrl: './floating-textarea.component.html',
  styleUrls: ['./floating-textarea.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TextFieldModule],
})
export class FloatingTextareaComponent {
  control = input.required<FormControl>();
  label = input.required<string>();
  minRows = input(1);
  maxRows = input(3);
  expandable = input(false);
}
